<template>
  <div class="con1" :style="{ height: tabShow === 0 ? '900px' : '1167px' }">
    <div class="con1_title">{{ title }}</div>
    <div class="con1_tab">
      <div class="tab_box">
        <div class="list">
          <div class="list_l" @click="tabShow = 0">{{ tabs[0].title }}</div>
          <div class="list_r" @click="tabShow = 1">{{ tabs[1].title }}</div>
        </div>
        <div :class="['active_stu', 'line', `active_stu${tabShow}`]"></div>
      </div>
      <div class="tab_con">
        <div class="tab_img" v-for="(tab, tabIdx) in tabs" :key="tabIdx" v-show="tabShow === tabIdx">
          <div
            class="tab_img_list"
            v-for="(title, index) in tab.items"
            :style="{ backgroundImage: `url(${tab.items[index].img})` }"
            :key="index"
          >
            <div class="txt">{{ tab.items[index].text }}</div>
          </div>
        </div>
        <div :class="[tabShow === 1 ? 'tab_qslc1' : 'tab_qslc2', 'tab_qslc']"></div>
        <div :class="[tabShow === 1 ? 'footer_bg0' : 'footer_bg1', 'tab_footer']"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    tabs: Array,
  },
  data() {
    return {
      tabShow: 0,
    }
  },
}
</script>

<style lang="less" scoped>
.con1 {
  width: 100%;
  height: 1009px;
  background: #fff;
  padding-top: 69px;
  animation-duration: 2s;
  animation-delay: 1s;
  animation-iteration-count: 1;

  .con1_title {
    font-size: 36px;
    color: #333;
    display: flex;
    justify-content: center;
  }

  .con1_tab {
    width: 1200px;
    margin: 70px auto 0;

    .tab_box {
      height: 45px;
      color: #333;
      font-size: 18px;
      font-weight: 400;
      flex-direction: row;
      border-bottom: 1px solid #e9e9e9;

      .list {
        width: 100%;
        height: 25px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;

        .list_l {
          padding-left: 207px;
        }

        .list_r {
          padding-right: 264px;
        }
      }

      .line {
        width: 200px;
        height: 19px;
        border-bottom: 1px solid #e61717;
        margin-left: 196px;
        position: relative;
      }

      .active_stu {
        animation-fill-mode: forwards;
        animation-duration: 0.3s;
        animation-timing-function: ease-out;
        position: relative;

        &1 {
          animation-name: lr;
        }

        &0 {
          animation-name: rl;
        }
      }
    }

    .tab_con {
      width: 100%;
      height: 628px;
      margin-top: 40px;

      .tab_img {
        width: 100%;
        height: 340px;
        display: flex;

        .tab_img_list {
          width: 300px;
          height: 340;
          background-size: cover;
          background-repeat: no-repeat;
          position: relative;
          margin: 0 1px;

          .txt {
            width: 100%;
            height: 40px;
            background: rgba(51, 51, 51, 0.9);
            font-size: 14px;
            position: absolute;
            bottom: 0;
            text-align: center;
            line-height: 40px;
            color: #fff;
          }
        }
      }

      .tab_qslc {
        width: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        margin-top: 30px;

        &1 {
          height: 390px;
          background-image: url(https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con1_qslc.png);
        }

        &2 {
          height: 110px;
          background-image: url(https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con1_qslc2.png);
        }
      }

      .tab_footer {
        width: 100%;
        height: 84px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-top: 26px;
      }

      .footer_bg0 {
        background-image: url(https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con1_bottom0.png);
      }

      .footer_bg1 {
        background-image: url('../../../../assets/images/con1_bottom1.png');
      }
    }
  }
}

@keyframes lr {
  0% {
    margin-left: 196px;
  }

  100% {
    margin-left: 784px;
  }
}

@keyframes rl {
  0% {
    margin-left: 784px;
  }

  100% {
    margin-left: 196px;
  }
}
</style>
